import React from 'react';
import { Link } from 'react-router-dom';
import { Card } from '../components/Card';
import { TrustScore } from '../components/TrustScore';
import { ExchangeCardSkeleton } from '../components/SkeletonLoader';
import { useExchangeData } from '../hooks/useExchangeData';
import { useCompare } from '../contexts/CompareContext';
import { PlusIcon, CheckIcon } from 'lucide-react';
export function ExchangesPage() {
  const {
    data: exchanges,
    loading
  } = useExchangeData();
  const {
    addToCompare,
    isInCompare
  } = useCompare();
  return <div className="min-h-screen bg-slate-50" data-id="element-543">
      <div className="bg-gradient-to-br from-slate-900 to-blue-900 text-white py-12" data-id="element-544">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-545">
          <h1 className="text-4xl font-bold mb-3" data-id="element-546">Top Crypto Exchanges</h1>
          <p className="text-slate-300 text-lg" data-id="element-547">
            Trusted reviews and comprehensive analysis of leading cryptocurrency
            exchanges
          </p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-548">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-549">
          {loading && exchanges.length === 0 ? Array.from({
          length: 6
        }).map((_, i) => <ExchangeCardSkeleton key={i} data-id="element-550" />) : exchanges.map(exchange => <Card key={exchange.id} className="p-6 h-full relative" data-id="element-551">
                  <Link to={`/exchange/${exchange.id}`} className="block" data-id="element-552">
                    <div className="flex items-start gap-4 mb-4" data-id="element-553">
                      <div className="flex items-center gap-3" data-id="element-554">
                        <span className="text-slate-500 font-semibold text-sm w-6" data-id="element-555">
                          {exchange.rank}
                        </span>
                        <img src={exchange.logo} alt={exchange.name} className="w-12 h-12 flex-shrink-0" data-id="element-556" />
                      </div>
                      <div className="flex-1" data-id="element-557">
                        <div className="flex items-center justify-between mb-2" data-id="element-558">
                          <h3 className="font-semibold text-xl" data-id="element-559">
                            {exchange.name}
                          </h3>
                          <TrustScore score={exchange.trustScore} size="sm" data-id="element-560" />
                        </div>
                        <p className="text-slate-600 text-sm line-clamp-2" data-id="element-561">
                          {exchange.description}
                        </p>
                      </div>
                    </div>

                    <div className="grid grid-cols-2 gap-4 mb-4" data-id="element-562">
                      <div data-id="element-563">
                        <div className="text-xs text-slate-500 mb-1" data-id="element-564">
                          24h Volume
                        </div>
                        <div className="font-semibold" data-id="element-565">
                          ${(exchange.tradingVolume / 1000000000).toFixed(2)}B
                        </div>
                      </div>
                      <div data-id="element-566">
                        <div className="text-xs text-slate-500 mb-1" data-id="element-567">
                          Supported Coins
                        </div>
                        <div className="font-semibold" data-id="element-568">
                          {exchange.supportedCoins}
                        </div>
                      </div>
                      <div data-id="element-569">
                        <div className="text-xs text-slate-500 mb-1" data-id="element-570">
                          Trading Fee
                        </div>
                        <div className="font-semibold" data-id="element-571">
                          {exchange.tradingFee}
                        </div>
                      </div>
                      <div data-id="element-572">
                        <div className="text-xs text-slate-500 mb-1" data-id="element-573">
                          Reviews
                        </div>
                        <div className="font-semibold" data-id="element-574">
                          {exchange.reviews.length} reviews
                        </div>
                      </div>
                    </div>

                    <div className="flex flex-wrap gap-2" data-id="element-575">
                      {exchange.features.slice(0, 3).map((feature, index) => <span key={index} className="text-xs bg-slate-100 text-slate-700 px-2 py-1 rounded" data-id="element-576">
                          {feature}
                        </span>)}
                      {exchange.features.length > 3 && <span className="text-xs text-slate-500 px-2 py-1" data-id="element-577">
                          +{exchange.features.length - 3} more
                        </span>}
                    </div>
                  </Link>

                  {/* Add to Compare Button */}
                  <button onClick={e => {
            e.preventDefault();
            addToCompare(exchange);
          }} className={`absolute top-4 right-4 px-3 py-1.5 rounded-lg font-medium text-sm transition-colors flex items-center gap-1.5 ${isInCompare(exchange.id) ? 'bg-green-100 text-green-700 border border-green-300' : 'bg-blue-600 text-white hover:bg-blue-700'}`} data-id="element-578">
                    {isInCompare(exchange.id) ? <>
                        <CheckIcon size={14} data-id="element-579" />
                        Added
                      </> : <>
                        <PlusIcon size={14} data-id="element-580" />
                        Compare
                      </>}
                  </button>
                </Card>)}
        </div>
      </div>
    </div>;
}